import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const StatementStatusesLookupState = (state: RootState) => state.lookups.statementStatuses;

export const selectStatementStatuses = (state: RootState) => StatementStatusesLookupState(state).rows;
export const selectStatementStatusesLoading = (state: RootState) => StatementStatusesLookupState(state).loading;

export const selectStatementStatusById = createSelector(
  [selectStatementStatuses, (_: RootState, id?: string) => id],
  (rows, id) => rows.find(({ id: rowId }) => id === rowId),
);

export const selectLookupStatementStatuses = createSelector(selectStatementStatuses, (rows) =>
  rows.map(({ id, name }) => ({ id, name })),
);
